module.exports = __webpack_public_path__ + "static/media/agdha.09643b0a.png";